<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JXTlN0/tc-custom/9780310540342.jpg?1736422877156" alt="This image is the cover for the book Miracle, Singing River Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Miracle, Singing River Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Raising four strong-willed younger siblings after her mother’s death and her father’s imprisonment, seventeen-year-old Lanie Freeman never knows what new adventure will roll into view—such as her brother’s wild idea to turn the family’s old truck into a traveling store. The Freeman Rolling Emporium could provide the financial security Lanie and her family so desperately need, or it could tear them apart. Yet it’s only a prelude to other changes. Author Brent Hayden’s arrival in Fairhope breathes fresh life into Lanie’s dream of becoming a writer. And then the hammer descends … Lanie’s father is diagnosed with cancer, and the faith and unity of her family are stretched to the limit. And on top of this shattering news, a crisis is about to strike that will rock the whole town of Fairhope—and shatter Lanie’s dreams of love. The Miracle continues the story of a young woman’s valiant struggle to uphold her faith, her family, and her dreams during the height of the Great Depression.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gilbert Morris
      </h2>
      
      <p class="authorDescription body article">Gilbert Morris is one of today’s best-known Christian novelists, specializing in historical fiction. His best-selling works include Edge of Honor (winner of a Christy Award in 2001), Jacob’s Way, The Spider Catcher, the House of Winslow series, the Appomattox series, and The Wakefield Saga. He lives in Gulf Shores, Alabama with his wife, Johnnie.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b645513